module.exports = __webpack_public_path__ + "static/media/file-JPG.0d79dbda.svg";